import { forwardRef } from "react";
import { Drawer as DrawerPrimitive } from "vaul";
import { useTranslations } from "next-intl";

import {
  DRAWER_CLOSE_CLASS,
  DRAWER_CLOSE_ICON,
  type TDrawerCloseElement,
  type TDrawerCloseProps,
} from "@/ui/components/overlay/Drawer/Drawer.config";
import { cn } from "@/ui/lib";
import { Icon } from "@/ui/components/primitives";

export const DrawerClose = forwardRef<TDrawerCloseElement, TDrawerCloseProps>(
  ({ "aria-label": ariaLabel, className, ...props }, ref) => {
    const t = useTranslations("Libs.UI.Components.Drawer.DrawerClose");

    return (
      <DrawerPrimitive.Close
        aria-label={ariaLabel ?? t("close")}
        data-component="DrawerClose"
        ref={ref}
        {...props}
        className={cn(DRAWER_CLOSE_CLASS, className)}
      >
        <Icon icon={DRAWER_CLOSE_ICON} />
      </DrawerPrimitive.Close>
    );
  },
);

DrawerClose.displayName = "DrawerClose";
